export function removeTrackingParams(
  url: string,
  trackingParams: readonly string[]
): string {
  const urlObj = new URL(url);

  trackingParams.forEach((param) => {
    if (param.endsWith('*')) {
      const prefix = param.slice(0, -1);
      [...urlObj.searchParams.keys()]
        .filter((key) => key.startsWith(prefix))
        .forEach((key) => urlObj.searchParams.delete(key));
      return;
    }

    urlObj.searchParams.delete(param);
  });

  return urlObj.toString();
}
